/** GraphQL query to get max bags count. */

export default `
  query getMaxBagsCount($cart_id: String!) {
    xmasGetMaxBagsCount(cart_id: $cart_id)
  }
`;
